import { render, staticRenderFns } from "./LeftCabinet.vue?vue&type=template&id=5312a9a3"
import script from "./LeftCabinet.vue?vue&type=script&lang=js"
export * from "./LeftCabinet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports